import { useEffect, useState } from "react";
import ReactPhoneInput from "react-phone-number-input";
import { Phone } from "lucide-react";
import { useProfile, useUpdateProfile, useInvalidateProfile } from "@/lib/api";
import { useT } from "@/lib/i18n";

/**
 * Phone + Instagram, edited under Settings (they're contact details, not part of
 * the public profile). Saves each field on blur. Moved here from the retired
 * /profile/edit page.
 */
export function ContactDetailsSection() {
  const { t } = useT();
  const { data } = useProfile({ staleTime: 0 });
  const updateProfile = useUpdateProfile();
  const invalidate = useInvalidateProfile();

  const u = data?.data?.user as any;
  const p = data?.data?.profile as any;
  const savedPhone = u?.phone || p?.phone || "";
  const savedInstagram = p?.instagram || u?.instagram || "";

  const [phone, setPhone] = useState(savedPhone);
  const [instagram, setInstagram] = useState(savedInstagram);
  const [seeded, setSeeded] = useState(false);

  useEffect(() => {
    if (!seeded && data?.data) {
      setPhone(savedPhone);
      setInstagram(savedInstagram);
      setSeeded(true);
    }
  }, [data, seeded, savedPhone, savedInstagram]);

  const savePhone = () => {
    if ((phone || "") !== (savedPhone || "")) {
      updateProfile.mutate({ phone: phone || "" }, { onSuccess: () => invalidate() });
    }
  };
  const saveInstagram = () => {
    if ((instagram || "") !== (savedInstagram || "")) {
      updateProfile.mutate({ instagram: instagram || "" }, { onSuccess: () => invalidate() });
    }
  };

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-4">
        <Phone className="w-5 h-5 text-primary-500" />
        <h2 className="text-xl font-semibold dark:text-neutral-100">Contact</h2>
      </div>

      <div className="space-y-4">
        <div className="space-y-1.5">
          <label htmlFor="settings-phone" className="input-label">
            {t("profile.fields.phone")}
          </label>
          <div
            onBlur={savePhone}
            className="input-glass-wrapper [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:border-0 [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:text-neutral-900 dark:[&_.PhoneInputInput]:text-neutral-50 [&_.PhoneInputInput]:placeholder-neutral-400 dark:[&_.PhoneInputInput]:placeholder-neutral-500 [&_.PhoneInputInput]:text-base [&_.PhoneInputCountrySelect]:text-neutral-900 dark:[&_.PhoneInputCountrySelect]:text-neutral-50 [&_.PhoneInputCountrySelectArrow]:text-neutral-500 dark:[&_.PhoneInputCountrySelectArrow]:text-neutral-400"
          >
            <ReactPhoneInput
              id="settings-phone"
              defaultCountry="US"
              value={phone}
              onChange={(value) => setPhone(value?.toString() || "")}
            />
          </div>
        </div>

        <div className="space-y-1.5">
          <label htmlFor="settings-instagram" className="input-label">
            {t("profile.fields.instagram")}
          </label>
          <input
            type="text"
            id="settings-instagram"
            inputMode="text"
            autoComplete="off"
            value={instagram}
            onChange={(e) => setInstagram(e.target.value.replace("@", ""))}
            onBlur={saveInstagram}
            placeholder="username"
            className="input-glass"
          />
        </div>
      </div>
    </div>
  );
}
